<template>
  <v-snackbar
    v-model="notification.show"
    :color="notification.type"
    :timeout="notification.persistent ? -1 : notification.timeout"
    multi-line
    class="notification-snackbar"
  >
    <div class="d-flex align-center">
      <v-icon
        class="mr-1"
        v-text="notification.type === 'success' ? icons.mdiCheckCircle : icons.mdiAlert"
      ></v-icon>
      <div v-if="notification.url" class="d-flex" style="width: 100%">
        <div class="d-inline pt-1">
          <span v-html="notification.text" class="subtitle-1 font-weight-bold text-center"> </span>
          <v-list-item
            :href="notification.url"
            target="_blank"
            rel="noopener"
            class="ml-n1 pa-2 subtitle-1 font-weight-bold d-inline justify-center text-decoration-underline notification-url"
            style="background-color: rgba(255, 255, 255, 0.1); border-radius: 4px"
            @click="closeNotification"
          >
            <span v-if="notification.urlText">{{ notification.urlText }}</span>
            <span v-else>{{ notification.url }}</span>
          </v-list-item>
        </div>
      </div>
      <span v-else v-html="notification.text" class="subtitle-1 font-weight-bold"> </span>
    </div>
    <template v-slot:action>
      <v-btn icon @click="closeNotification">
        <v-icon v-text="icons.mdiClose"></v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mdiCheckCircle, mdiAlert, mdiClose } from '@mdi/js';
import { mapMutations } from 'vuex';

export default {
  name: 'Notification',

  data: () => ({
    icons: { mdiCheckCircle, mdiAlert, mdiClose },
  }),

  computed: {
    notification() {
      return this.$store.state.notification;
    },
    lang() {
      return this.$route.params.lang;
    },
  },

  methods: {
    ...mapMutations(['setNotification']),
    closeNotification() {
      this.setNotification({
        show: false,
        type: this.notification.type,
        text: this.notification.text,
      });
    },
  },
};
</script>
<style>
.notification-url * {
  display: inline !important;
}
.notification-snackbar .v-snack__content {
  padding-right: 0% !important;
}
</style>
